import { createStore } from 'vuex';

const store = createStore({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    business: JSON.parse(localStorage.getItem('business')) || null
  },

  mutations: {
    setUser(state, newUser) {
      state.user = newUser;

      if (newUser) {
        localStorage.setItem('user', JSON.stringify(newUser));
      } else {
        localStorage.removeItem('user');
      }
    },

    setBusiness(state, newBusiness) {
      state.business = newBusiness;

      if (newBusiness) {
        localStorage.setItem('business', JSON.stringify(newBusiness));
      } else {
        localStorage.removeItem('business');
      }
    }
  },

  actions: {
    saveUser({ commit }, newUser) {
      commit('setUser', newUser);
    },

    saveBusiness({ commit }, newBusiness) {
      commit('setBusiness', newBusiness);
    }
  },

  getters: {
    getUser(state) {
      return state.user;
    },

    getBusiness(state) {
      return state.business;
    }
  }
});

export default store;